var Haiku = require("@haiku/core");
var _code_scribble_code = require("./../scribble/code.js");
var _code_zigzag_code = require("./../zigzag/code.js");
var _code_arrowdash_code = require("./../arrowdash/code.js");
module.exports = {
  metadata: {
    uuid: "cc628224-92a6-4d0d-9dc3-fe0f89e7254b",
    version: "0.0.5",
    organization: "Tina",
    project: "LearnPage",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/LearnPage",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/7ccc2013-ef9a-4bd4-bc8c-0eed8a54e5d2/50f3dd5aa4acacabe79e12bf8506a9ce1918629a/",
    core: "4.5.0",
    title: "Main",
    type: "haiku",
    relpath: "code/main/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Zigzag-3cc7eba9094ad34e": {
        "sizeAbsolute.x": "auto",
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.x": 402.42699462890624,
        "translation.y": 175,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 2
      },
      "haiku:Linear-Gradient-1-183132-1011d481e325d1e7": {
        x1: "11.4598703%",
        y1: "49.2716583%",
        x2: "81.5438343%",
        y2: "50.7078201%"
      },
      "haiku:Scribble-6c92ac9953fe3bcc": {
        "sizeAbsolute.x": "auto",
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.x": 710.9819677734375,
        "translation.y": 233.199,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 3
      },
      "haiku:Learn-2-0f1f3322e60a91c6": {
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 500,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 70,
        "sizeMode.y": 1,
        "translation.x": 450,
        "translation.y": 175,
        "style.zIndex": 4
      },
      "haiku:Arrowdash-9546ba400be29339": {
        "sizeAbsolute.x": "auto",
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.x": 129.053,
        "translation.y": 145.9715,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 1
      },
      "haiku:Main-03757d2ca1026e0a": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "hidden",
        "style.overflowY": "hidden",
        "sizeAbsolute.x": 900,
        "sizeAbsolute.y": 350,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1,
        "style.backgroundColor": { "0": { value: "#222B39", edited: true } }
      },
      "haiku:Stop-4794d3bba005ce8c": { stopColor: "#EF33F8", offset: "0%" },
      "haiku:Stop-2c5e6a434625afc0": { stopColor: "#F75D4A", offset: "100%" },
      "haiku:Page-1-a72a64ecef074485": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-b025fe3b3b62f80d": {
        fill: "url(#linearGradient-1-183132)",
        fillRule: "nonzero",
        "translation.x": -200,
        "translation.y": -140
      },
      "haiku:Learn-2-968161d66115ca01": {
        d:
          "M209.238885,202.9 L233.638885,202.9 L233.638885,209.9 L200.138885,209.9 L200.138885,140.2 L209.238885,140.2 L209.238885,202.9 Z M307.994443,147.3 L307.994443,171.2 L333.394443,171.2 L333.394443,178.2 L307.994443,178.2 L307.994443,202.7 L336.394443,202.7 L336.394443,209.9 L298.894443,209.9 L298.894443,140.1 L336.394443,140.1 L336.394443,147.3 L307.994443,147.3 Z M446.95,194.4 L416.55,194.4 L410.95,209.9 L401.35,209.9 L426.55,140.6 L437.05,140.6 L462.15,209.9 L452.55,209.9 L446.95,194.4 Z M444.45,187.3 L431.75,151.8 L419.05,187.3 L444.45,187.3 Z M565.405557,209.9 L548.805557,181.4 L537.805557,181.4 L537.805557,209.9 L528.705557,209.9 L528.705557,140.2 L551.205557,140.2 C556.47225,140.2 560.922206,141.099991 564.555557,142.9 C568.188909,144.700009 570.905548,147.133318 572.705557,150.2 C574.505566,153.266682 575.405557,156.766647 575.405557,160.7 C575.405557,165.500024 574.022238,169.733315 571.255557,173.4 C568.488877,177.066685 564.338918,179.499994 558.805557,180.7 L576.305557,209.9 L565.405557,209.9 Z M537.805557,174.1 L551.205557,174.1 C556.138915,174.1 559.838878,172.883345 562.305557,170.45 C564.772236,168.016654 566.005557,164.766687 566.005557,160.7 C566.005557,156.499979 564.805569,153.233345 562.405557,150.9 C560.005545,148.566655 556.272249,147.4 551.205557,147.4 L537.805557,147.4 L537.805557,174.1 Z M699.861115,209.9 L690.761115,209.9 L654.161115,154.4 L654.161115,209.9 L645.061115,209.9 L645.061115,140.1 L654.161115,140.1 L690.761115,195.5 L690.761115,140.1 L699.861115,140.1 L699.861115,209.9 Z"
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Learn-2-0f1f3322e60a91c6",
          "haiku-title": "LEARN-2",
          "haiku-source": "designs/LearnPage.sketch.contents/slices/LEARN-2.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-2084d95506628f4a" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-183132-1011d481e325d1e7",
                  id: "linearGradient-1-183132"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-4794d3bba005ce8c" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-2c5e6a434625afc0" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-a72a64ecef074485", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-b025fe3b3b62f80d",
                  id: "Artboard"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "Learn-2-968161d66115ca01",
                      id: "LEARN-2"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: _code_scribble_code,
        attributes: {
          "haiku-id": "Scribble-6c92ac9953fe3bcc",
          "haiku-var": "_code_scribble_code",
          "haiku-title": "Scribble",
          "haiku-source": "./code/scribble/code.js"
        },
        children: []
      },
      {
        elementName: _code_zigzag_code,
        attributes: {
          "haiku-id": "Zigzag-3cc7eba9094ad34e",
          "haiku-var": "_code_zigzag_code",
          "haiku-title": "Zigzag",
          "haiku-source": "./code/zigzag/code.js"
        },
        children: []
      },
      {
        elementName: _code_arrowdash_code,
        attributes: {
          "haiku-id": "Arrowdash-9546ba400be29339",
          "haiku-var": "_code_arrowdash_code",
          "haiku-title": "Arrowdash",
          "haiku-source": "./code/arrowdash/code.js"
        },
        children: []
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-learnpage/code/main/code.js
// module id = 464
// module chunks = 127651196306611